import styled, { css } from "styled-components";
import React from "react";
import DefaultTitle from "./Title";
import DefaultText from "./Text";
import TextNice from "./TextNice";

const TitleNice = (props) => <DefaultTitle.Small {...props} />;

TitleNice.Subtitle = (props) => (
  <DefaultTitle.Small innerAs="h3" black {...props} />
);

TitleNice.InlineHeader = (props) => (
  <TextNice
    as="h3"
    // fontSize="22px"
    lineHeight="30px"
    style={{ display: "inline", color: "#000" }}
    {...props}
  />
);

export default TitleNice;
